import { safeDecodeURIComponent } from '@intelligence/v3/utils/common';

export const getPDFPreviewDownloadUrlParams = (
  search: string,
): {
  [key: string]: string;
} => {
  const urlSearchParams = new URLSearchParams(search.slice(1));
  return Array.from(urlSearchParams.entries()).reduce((current, next) => {
    const [param, value] = next || [];
    return {
      ...current,
      [param]: value ? safeDecodeURIComponent(value) : '',
    };
  }, {});
};
